import React, { useEffect } from "react";

type StatusMap = Record<string, number>;
type Props = {
  data?: StatusMap;
  onFilterChange?: (filter: string) => void;
  activeFilter?: string;
};

const DynamicFilters: React.FC<Props> = ({
  data = {},
  onFilterChange,
  activeFilter = "All",
}) => {
  const keys = Object.keys(data);

  useEffect(() => {
    localStorage.setItem("statusActiveTab", activeFilter);
  }, [activeFilter]);

  const handleClick = (key: string) => {
    onFilterChange?.(key);
    console.log("Clicked key:", key);
  };

  if (keys.length === 0) return null;

  return (
    <div className="bg-neutral-100 rounded-lg mb-2">
      <div className="px-2 flex gap-4 border-b-2 border-neutral-200 flex-wrap">
        {keys.map((key) => {
          const isActive = key === activeFilter;
          return (
            <div
              key={key}
              onClick={() => handleClick(key)}
              className={`p-3 font-semibold cursor-pointer text-sm capitalize select-none ${
                isActive
                  ? "border-b-2 border-red-500 text-red-500"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              {key} ({data[key]})
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DynamicFilters;